module.exports = __webpack_public_path__ + "static/desktop/img/bh-two.ccef06ed.jpg";